import { render } from "./CreateService.vue?vue&type=template&id=2af96a9b"
import script from "./CreateService.vue?vue&type=script&lang=js"
export * from "./CreateService.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__